import type { PostOrdergrooveAddSubscription } from '../types';

export const createPostOrdergrooveAddSubscriptionBody = ({
    productId,
    quantity,
    frequencyAmount,
    unitOfMeasure,
    basketId,
    publicId,
    customerId,
    isOneTimeOrder,
}: PostOrdergrooveAddSubscription): PostOrdergrooveAddSubscription => {
    if (isOneTimeOrder) {
        return {
            productId,
            quantity,
            frequencyAmount: null,
            unitOfMeasure: null,
            basketId,
            publicId,
            customerId,
            isOneTimeOrder,
        };
    }

    // Recurring order
    return {
        productId,
        quantity,
        frequencyAmount,
        unitOfMeasure,
        basketId,
        publicId,
        customerId,
        isOneTimeOrder,
    };
};
